export class WalletSaveModule {
    constructor(_provider, _userId) {
        this._provider = _provider;
        this._userId = _userId;
        this.version = 1;
        this._data = null;
    }
    getKey() {
        return `saves/${this._userId}/modules/economy`;
    }
    save(data) {
        this._data = data;
        void this._provider.set(this.getKey(), data);
    }
    /**
     * Module 137 — `save`, but resolves when the provider has taken the write, so
     * a caller can read the record back before it acts on it (a real-money grant
     * is consumed only once its save is confirmed).
     */
    saveAndFlush(data) {
        this._data = data;
        return this._provider.set(this.getKey(), data);
    }
    /** modules/economy is server-write-only (Cloud Function / Postgres RPC) — hydrating from a read must never attempt a remote write. */
    hydrate(data) {
        this._data = data;
    }
    load() {
        return this._data;
    }
    migrate(old, fromVersion) {
        if (fromVersion === 0) {
            return { coins: 0, gems: 0, version: 1 };
        }
        return old;
    }
}
